import { Model } from '@shared/models/model';
import { Expose } from 'class-transformer';

export class MadarPerformance extends Model {
 @Expose() customerId?: number;
 @Expose() shipmentCount?: number;
 @Expose() title?: string;
 @Expose() salesRevenue: number;
 @Expose() transportationCost: number;
 @Expose() profitMargin: number;
 @Expose() margin: number;
}
